import {
  CLOSE_COHORT_CONFIG_TOAST,
  CLOSE_DIALOG,
  GET_COHORT_CONFIG,
  OPEN_COHORT_CONFIG_DIALOG,
  OPEN_COHORT_CONFIG_TOAST,
  UPDATE_COHORT_CONFIG,
} from "./cohortConfig.type";

const initialState = {
  cohortConfigs: [],
  dialog: false,
  dialogData: null,
  toast: false,
  toastData: null,
  actionFor: null,
  toastCohortKey: null,
};

const cohortConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COHORT_CONFIG:
      return { ...state, cohortConfigs: action.payload };

    case UPDATE_COHORT_CONFIG:
      return {
        ...state,
        cohortConfigs: state.cohortConfigs.map((cfg) =>
          cfg.cohortKey === action.payload.cohortKey
            ? { ...cfg, ...action.payload.patch }
            : cfg
        ),
      };

    case OPEN_COHORT_CONFIG_DIALOG:
      return { ...state, dialog: true, dialogData: action.payload || null };

    case CLOSE_DIALOG:
      return { ...state, dialog: false, dialogData: null };

    case OPEN_COHORT_CONFIG_TOAST:
      return {
        ...state,
        toast: true,
        toastData: action.payload.data || null,
        actionFor: action.payload.for || null,
        toastCohortKey: action.payload.cohortKey || null,
      };

    case CLOSE_COHORT_CONFIG_TOAST:
      return {
        ...state,
        toast: false,
        toastData: null,
        actionFor: null,
        toastCohortKey: null,
      };

    default:
      return state;
  }
};

export default cohortConfigReducer;
